module.exports = __webpack_public_path__ + "img/Sao Tome and Principe.b28cf810.gif";